import { castleConstants, alertConstants } from '../_constants'
const initialState = {
  isLoading: false,
  summary:null,
  singleEntry:null,
  message:null,
  successMessage:null,
  error:null,
  isExpand:true
}

export function castle(state = { ...initialState }, action) {
  switch (action.type) {
  case castleConstants.ADD_REQUEST:
  case castleConstants.SUMMARY_REQUEST:
  case castleConstants.GET_REQUEST:
    return {
      ...state,
      isLoading: true,
    }
  case castleConstants.GET_SUCCESS:
    return {
      ...state,
      isLoading: false,
      singleEntry: action.result
    }
    case castleConstants.UPDATE_TOOL_TIP:
      return {
        ...state,
        isExpand:action.isExpand
      }  
  case castleConstants.SUMMARY_SUCCESS:
    return {
      ...state,
      isLoading: false,
      summary: action.summary.data,
      message: action.summary.message,
      successMessage:null

    }
  case castleConstants.ADD_SUCCESS:
    return {
      ...state,
      isLoading: false,
      singleEntry: action.result,
      successMessage:'Castle Settings Saved Successfully'
    }
  case castleConstants.ADD_FAILURE:
  case castleConstants.SUMMARY_FAILURE:
  case castleConstants.GET_FAILURE:
    return {
      ...state,
      isLoading: false,
      singleEntry: null,
      isError: true,
      error: action.error,
      successMessage:null
    }
  case alertConstants.CLEAR:
    return {
      ...state,
      message:null,
      error:null,
      isError:false
    }
  default:
    return { ...state }
  }
}
